/** Every fifth rotation slot links to local specials; don't replace real records. */
export type RotationSlot<T> = {kind:'item';item:T} | {kind:'specials'};
export function everyFifthSpecials<T>(items:readonly T[]): RotationSlot<T>[] {
  const output: RotationSlot<T>[] = [];
  for(const item of items) {
    if(output.length>0 && (output.length+1)%5===0) output.push({kind:'specials'});
    output.push({kind:'item',item});
  }
  return output;
}
/** Third homepage card is a flyer; subsequent advertisers appear after every
 * fourth additional article. No real article is removed to make space. */
export function homepageFlyerSlotAfter(index: number): boolean {
  return index === 1 || (index >= 5 && (index - 1) % 4 === 0);
}

/** Distribute every current published flyer once per rotation, with no duplicates
 * when only one store is participating. Missing article feeds can still show
 * dated, eligible store flyers. */
export type HomepageRotationSlot<T, F> =
  | { kind: "article"; article: T; index: number }
  | { kind: "flyer"; flyer: F };

export function buildHomepageRotationSlides<T, F>(
  articles: readonly T[],
  flyers: readonly F[],
): HomepageRotationSlot<T, F>[] {
  const result: HomepageRotationSlot<T, F>[] = [];
  let flyerIndex = 0;
  articles.forEach((article, index) => {
    result.push({ kind: "article", article, index });
    if (flyerIndex < flyers.length &&
        (homepageFlyerSlotAfter(index) || (articles.length === 1 && index === 0))) {
      result.push({ kind: "flyer", flyer: flyers[flyerIndex++] });
    }
  });
  // Extra flyers must get a turn too, even if fewer articles were published.
  for (; flyerIndex < flyers.length; flyerIndex++) {
    result.push({ kind: "flyer", flyer: flyers[flyerIndex] });
  }
  return result;
}

/** Long archive: flyers after every five editorial articles. */
export function archiveFlyerAfter(index:number): boolean {return index>=4&&(index+1)%5===0;}
